import React from "react";
import { loadServicesIntoTable } from "../../../thunks/tableThunks";
import { useAppDispatch } from "../../../store";
import { Service, fetchServices, restartService } from "../../../slices/serviceSlice";
import ButtonLikeAnchor from "../../shared/ButtonLikeAnchor";

/**
 * This component renders the action cells of services in the table view
 */
const ServicesActionCell = ({
	row,
}: {
	row: Service
}) => {
	const dispatch = useAppDispatch();

	const onClickRestart = async () => {
		await dispatch(restartService({host: row.hostname, serviceType: row.name}));
		await dispatch(fetchServices());
		dispatch(loadServicesIntoTable());
	};

	return (
		row.status !== "SYSTEMS.SERVICES.STATUS.NORMAL" ? (
			<ButtonLikeAnchor
				onClick={() => onClickRestart()}
				className={"sanitize fa fa-undo"}
				editAccessRole={"ROLE_UI_SERVICES_STATUS_EDIT"}
				// tooltipText={"SYSTEMS.SERVICES.TABLE.SANITIZE"} // Disabled due to performance concerns
			/>
		) : <></>
	);
};

export default ServicesActionCell;
